import { ValidationReason, ValidationStatus } from '../types';

export const VALIDATION_STATUS_LABELS: Record<ValidationStatus, string> = {
  confirmed: 'Confirmed',
  false_positive: 'False Positive',
  partially_confirmed: 'Partially Confirmed',
  not_applicable: 'Not Applicable',
  needs_clarification: 'Needs Clarification',
  duplicate: 'Duplicate',
  accepted_risk: 'Accepted Risk'
};

export const VALIDATION_REASON_LABELS: Record<ValidationReason, string> = {
  scope_exception: 'Scope Exception',
  definition_missed: 'Definition Missed',
  outdated_doc: 'Outdated Document',
  temporal_mismatch: 'Temporal Mismatch',
  wrong_entity_type: 'Wrong Entity Type',
  retrieval_wrong_chunk: 'Retrieval - Wrong Chunk',
  other: 'Other'
};
